import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, map } from 'lodash/fp'
import { GraphLineCompare } from 'features/CallAnalytics/GraphLineCompare'
import { moment } from 'features/Moment'
import { unitOfTime } from 'moment'
import { unionBy, orderBy, meanBy } from 'lodash'
import { mapWithKey } from '../../../../utils/lodash'
import { ICall, IDateVal } from 'features/CallAnalytics/types'

const formatData = (data: ICall[], sumPeriod: unitOfTime.StartOf): IDateVal[] =>
  flow<ICall[], any, any, IDateVal[]>(
    map((call: ICall) => ({
      ...call,
      dateTime: moment(call.dateTime)
        .local()
        .startOf(sumPeriod)
        .format(),
    })),
    groupBy('dateTime'),
    mapWithKey(items => ({
      date: items[0].dateTime,
      value: meanBy(items, 'duration'),
    }))
  )(data)

const add1Period = (data, periodValue, periodUnit) =>
  data.map(call => ({
    ...call,
    dateTime: moment(call.dateTime)
      .add(periodValue, periodUnit)
      .format(),
  }))

export const CallsTrendsDuration = ({
  calls,
  callsPrevious,
  dateInterval,
  sumPeriod,
  periodValue,
  periodUnit,
  dateFormat,
  loading,
}) => {
  const baseData = dateInterval.map(date => ({ date, value: 0 }))
  const data1Raw = formatData(calls, sumPeriod)
  const data2Raw = formatData(add1Period(callsPrevious, periodValue, periodUnit), sumPeriod)
  const data1 = orderBy(unionBy(data1Raw, baseData, 'date'), 'date')
  const data2 = orderBy(unionBy(data2Raw, baseData, 'date'), 'date')

  return (
    <InfoCard style={{ height: '100%' }} title="Call duration" loading={loading} allowOverflow>
      <ParentSize>
        {({ width }) => (
          <GraphLineCompare
            width={width}
            height={400}
            data1={data1}
            data2={data2}
            label="Avg Duration"
            unit="min"
            dateFormat={dateFormat}
          />
        )}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsTrendsDuration/CallsTrendsDuration.tsx